import { useEffect } from 'react';

import { useQuery } from '@tanstack/react-query';
import { ADD_ORG_DATA } from 'actions/actionTypes';
import { sendRequest } from 'api/sendRequest';
import { useDispatch } from 'react-redux';

import { endpoints } from 'constants/endpoints';

import { getObjectiveSettings } from 'services/admin';

import { REACT_QUERY_GOALS_ACCESS_CONTROL } from '../constants';
import { getAllTemplatesV1 } from '../services';

export const useAllTemplatesQuery = () =>
  useQuery([REACT_QUERY_GOALS_ACCESS_CONTROL.allTemplates], () => getAllTemplatesV1());

export const useGoalFrequencyData = (enabled = true) => {
  const dispatch = useDispatch();
  const { data, isLoading, isFetching, ...rest } = useQuery({
    queryKey: [REACT_QUERY_GOALS_ACCESS_CONTROL.goalsFrequency],
    queryFn: getObjectiveSettings,
    refetchInterval: 1000 * 60 * 60, // 1 hour
    enabled,
  });

  useEffect(() => {
    if (data) {
      dispatch({
        type: ADD_ORG_DATA,
        data,
      });
    }
  }, [data, dispatch]);

  return {
    data,
    isLoading,
    isFetching,
    ...rest,
  };
};

const getGoalConfigurations = async () => {
  try {
    const url = endpoints.admin.goalConfigV1.goalsConfigurations;
    const res = await sendRequest({
      url,
      credentials: 'include',
    });
    return res?.entity;
  } catch (error) {
    console.error('Error fetching goal configurations:', error);
    throw error;
  }
};

export const useGoalConfigurations = (enabled) => {
  const dispatch = useDispatch();
  const { data, isLoading, isFetching, ...rest } = useQuery({
    queryKey: [REACT_QUERY_GOALS_ACCESS_CONTROL.goalsConfigurations],
    queryFn: getGoalConfigurations,
    refetchInterval: 1000 * 60 * 60, // 1 hour
    enabled,
  });
  useEffect(() => {
    if (data) {
      dispatch({ type: ADD_ORG_DATA, data });
    }
  }, [data, dispatch]);
  return {
    data,
    isLoading,
    isFetching,
    ...rest,
  };
};
